/**
 * Get the current base URL based on the environment
 */
export function getBaseUrl(): string {
  if (typeof window === 'undefined') {
    return '';
  }

  const isDev = import.meta.env.VITE_APP_ENV === 'development';
  const origin = window.location.origin;

  // In development, use localhost:3000
  // if (isDev) {
  //   return 'http://localhost:3000';
  // }

  // In production, use the current origin
  return origin;
}

/**
 * Get the redirect URL for OAuth callbacks
 */
export function getAuthRedirectUrl(): string {
  const baseUrl = getBaseUrl();
  return `${baseUrl}/auth/callback`;
}

/**
 * Navigate to a path using the correct base URL
 */
export function navigateTo(path: string): void {
  const baseUrl = getBaseUrl();
  const fullUrl = path.startsWith('/') ? `${baseUrl}${path}` : path;
  window.location.href = fullUrl;
}

/**
 * Check if we're in development mode
 */
export function isDevelopment(): boolean {
  return import.meta.env.VITE_APP_ENV === 'development';
}

/**
 * Check if we're in production mode
 */
export function isProduction(): boolean {
  return import.meta.env.VITE_APP_ENV === 'production';
}